import { makeStyles } from '@material-ui/core';
export default makeStyles(function (theme) {
  var _root;
  return {
    root: (_root = {
      width: '1.25em',
      height: '1.25em',
      marginLeft: -8,
      marginRight: -4
    }, _root[theme.breakpoints.down('sm')] = {
      marginLeft: -22,
      marginRight: -2
    }, _root)
  };
});